import { createApiClient } from '@monorepo/api-client';

const interceptors = (service: string) => ({
  response: {
    onRejected: () => {
      // FIXME sentry captureException.
      console.log(`${service} sentry captureException`);
    },
  },
});

export const giftApi = createApiClient({
  baseURL: import.meta.env.VITE_APP_MUSINSA_API_URL,
  headers: {
    Accept: 'application/json',
  },
  interceptors: interceptors('gift'),
});

export const likeApi = createApiClient({
  baseURL: import.meta.env.VITE_APP_API_LIKE_URL,
  headers: {
    Accept: 'application/json',
  },
  interceptors: interceptors('like'),
});

export const mypageApi = createApiClient({
  baseURL: import.meta.env.VITE_APP_API_MYPAGE_URL,
  headers: {
    Accept: 'application/json',
  },
  interceptors: interceptors('mypage'),
});
